import React, { useContext } from 'react';
import { ConfirmModal } from '@mummssoftware/common-ui';
import { HopeGlobalContext } from '@mummssoftware/global-context';
import { visitHeaderID } from '@mummssoftware/utils/constants';
import {
  SET_IS_HOPE_VISIT,
  SET_HOPE_VISIT_PROMPT_DISPLAY,
} from '@mummssoftware/global-context/HopeGlobalContext';
import { VisitContext } from '../Context/contexts/VisitContext';
import { SET_HOPE_VISIT_WARNING } from '../Context/constants';
import { HopeVisitContent } from './HopeVisitContent';
import defaults from '../../translations/en.json';

/** HOPE milestone Yes/No. Rendered in VisitPromptStack above the EA card. */
export const HopeVisitPromptCard = () => {
  const { dispatch: dispatchHopeGlobal } = useContext(HopeGlobalContext);
  const {
    checkforOtherUserHopeVisits,
    dispatchVisit,
    persistHopeVisitAttributes,
  } = useContext(VisitContext);

  const onCancelClick = () => {
    dispatchHopeGlobal({ type: SET_IS_HOPE_VISIT, payload: false });
    dispatchHopeGlobal({ type: SET_HOPE_VISIT_PROMPT_DISPLAY, payload: false });
    persistHopeVisitAttributes({ isHopeVisit: false });
  };

  const onOKClick = async () => {
    const inProg = await checkforOtherUserHopeVisits();

    if (inProg) {
      const el = document.getElementById(visitHeaderID);
      dispatchVisit({ type: SET_HOPE_VISIT_WARNING, payload: el });
      onCancelClick();
      return;
    }

    dispatchHopeGlobal({ type: SET_IS_HOPE_VISIT, payload: true });
    dispatchHopeGlobal({ type: SET_HOPE_VISIT_PROMPT_DISPLAY, payload: false });
    // SIA is not opened here; the user opens it from the HOPE icon in the visit header
    await persistHopeVisitAttributes({ isHopeVisit: true });
  };

  return (
    <ConfirmModal
      onOKClick={onOKClick}
      onCancelClick={onCancelClick}
      okText={defaults.yes}
      noText={defaults.no}
      modalText={defaults.HopeMilestone}
      content={<HopeVisitContent />}
    />
  );
};
